// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3IDSE","emails":"CreateEditClinics_emails__20dNm","emailTagLabel":"CreateEditClinics_emailTagLabel__Xh3iQ"};